module.exports = __webpack_public_path__ + "static/media/alis01.12a29651.jpg";